
export const threeGeomFixedVertShader = `
precision highp float;

uniform vec3 u_plate_tl;
uniform vec3 u_plate_tr;
uniform vec3 u_plate_br;
uniform vec3 u_plate_bl;
uniform vec3 u_plate_tl_up;
uniform vec3 u_plate_tr_up;
uniform vec3 u_plate_br_up;
uniform vec3 u_plate_bl_up;
uniform float u_plate_up_scale;
uniform float u_plate_height;
uniform float u_plate_width;

uniform mat4 u_matrix_globe_merc;

uniform float u_zoom_transition;
uniform vec2 u_centerInMerc;
uniform float u_pixelsPerMeterRatio;

uniform float u_scale_factor;
uniform float u_map_zoom;

varying vec3 vColor;

vec3 ecefVector(vec3 pos) {

    vec2 uv = vec2((pos.x - u_plate_tr.x) / u_plate_width, (pos.y - u_plate_tl.y) / u_plate_height);
    
    vec3 up = normalize(mix(mix(u_plate_tr_up, u_plate_tl_up, uv.xxx), mix(u_plate_bl_up, u_plate_br_up, uv.xxx), uv.yyy));

    return up * u_plate_up_scale * (1.0 + (pos.z * u_scale_factor));

}

float getZoomScaleFactor() {
    float baseSize = 10.0;
    return baseSize / pow(2.0, u_map_zoom);
}


void main(void){
    float zoomScale = getZoomScaleFactor();

    vec3 scaledPosition = position * zoomScale;

    vec3 pos = vec3(instanceMatrix * vec4(scaledPosition, 1.0));

    vec4 p;

    if (u_zoom_transition == 1.0) {

        p = projectionMatrix * vec4(pos, 1.0);

    } else {

        p = projectionMatrix * u_matrix_globe_merc * vec4(ecefVector(pos), 1.0);

        if (u_zoom_transition >= 0.0) {

            vec4 merc = vec4(pos, 1.0);

            merc.xy = (merc.xy - u_centerInMerc) * u_pixelsPerMeterRatio + u_centerInMerc;
            merc.z *= u_pixelsPerMeterRatio;
            merc = projectionMatrix * merc;

            p = mix(p, merc, u_zoom_transition);
            
        }
        
    }

    gl_Position = p;

    vColor = instanceColor;

}
`;

export const threeGeomFixedFragShader = `
varying vec3 vColor;
    
void main() {
      
    gl_FragColor = vec4(vColor, 1.0);
    
}
`;
